import Vue from 'vue';
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
// import relativeTime from 'dayjs/plugin/relativeTime'; // time ago
require('dayjs/locale/es');

dayjs.locale('es');
// dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);
dayjs.extend(isSameOrAfter);

Object.defineProperty(Vue.prototype, '$dayjs', { value: dayjs });


export default dayjs;